/**
 * Comparar texto como lo escribe la gente.
 *
 * ── Por qué no basta con `toLowerCase()` ────────────────────────────────────
 * Nadie escribe los acentos al buscar. «articulo» no encontraba «Artículo»,
 * «reserva» sí pero «Reservación» no aparecía por «reservacion», y buscar
 * «ingles» no daba con «Inglés». En español eso convierte el buscador en algo
 * que a veces funciona, que es peor que uno que no está: se concluye que el
 * elemento no existe.
 *
 * Se quitan las marcas diacríticas de las DOS partes, no sólo de la escrita: si
 * sólo se normalizara la consulta, «Inglés» seguiría sin poder encontrarse.
 *
 * ── La ñ se queda ───────────────────────────────────────────────────────────
 * `NFD` separaría la tilde de la ñ y la volvería una n, con lo que «ano»
 * encontraría «año». En español la ñ es una letra distinta, no una n con
 * adorno, así que se protege antes de descomponer y se devuelve después.
 */
/** El texto listo para comparar: sin acentos, en minúsculas y sin espacios de sobra. */
export function foldText(value) {
    if (!value)
        return '';
    return value
        .normalize('NFD')
        /* La ñ y la Ç se recomponen: son letras propias, no vocales con tilde. */
        .replace(/ñ/g, 'ñ')
        .replace(/Ñ/g, 'ñ')
        .replace(/ç/gi, 'ç')
        .replace(/[̀-ͯ]/g, '')
        .toLocaleLowerCase('es')
        .trim();
}
/**
 * Si un texto contiene lo buscado, sin que importen los acentos.
 *
 * Una consulta vacía encaja siempre: es «no estoy filtrando», no «no encuentro
 * nada», y devolver una lista vacía al borrar el buscador es de las cosas que
 * más desconciertan.
 */
export function matchesSearch(haystack, query) {
    const needle = foldText(query);
    if (!needle)
        return true;
    return foldText(haystack).includes(needle);
}
//# sourceMappingURL=searchText.js.map